import { Button, Label, Modal, ModalBody, ModalHeader, TextInput } from "flowbite-react";
import type { FC } from "react";
import { useState } from "react";
import { HiPlus } from "react-icons/hi";
import { createCommissionLevel } from "../../../services/commission-levels";

interface AddCommissionLevelModalProps {
  onUpdate: () => Promise<void>;
}

export const AddCommissionLevelModal: FC<AddCommissionLevelModalProps> = function ({
  onUpdate,
}) {
  const [isOpen, setOpen] = useState(false);
  const [levelNumber, setLevelNumber] = useState<number>(0);
  const [description, setDescription] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setIsProcessing(true);
      await createCommissionLevel({
        level_number: levelNumber,
        description,
      });
      await onUpdate();
      setOpen(false);
      setLevelNumber(0);
      setDescription("");
    } catch (error) {
      console.error("Failed to create commission level:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <>
      <Button color="primary" onClick={() => setOpen(true)}>
        <HiPlus className="mr-2 text-lg" />
        Level hinzufügen
      </Button>
      <Modal onClose={() => setOpen(false)} show={isOpen}>
        <ModalHeader className="border-b border-gray-200 !p-6 dark:border-gray-700">
          <strong>Neues Provisions-Level hinzufügen</strong>
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <Label htmlFor="levelNumber">Level Nummer</Label>
                <TextInput
                  id="levelNumber"
                  name="levelNumber"
                  type="number"
                  placeholder="z.B. 1"
                  value={levelNumber}
                  onChange={(e) => setLevelNumber(parseInt(e.target.value))}
                  required
                />
              </div>
              <div>
                <Label htmlFor="description">Beschreibung</Label>
                <TextInput
                  id="description"
                  name="description"
                  placeholder="z.B. Senior Sales"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="mt-6 flex items-center gap-x-3">
              <Button color="primary" type="submit" disabled={isProcessing}>
                Hinzufügen
              </Button>
              <Button color="gray" onClick={() => setOpen(false)}>
                Abbrechen
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};
